const ProductRoutine = {
  root: window.Shopify?.routes?.root || "/",

  init(section) {
    const root = section || document;

    root.querySelectorAll("[data-product-routine]").forEach((routine) => {
      if (routine.dataset.routineReady) return;

      routine.dataset.routineReady = "true";
      routine.addEventListener("change", (event) => {
        if (!event.target.matches(".product-routine__checkbox")) return;
        this.updateItem(routine, event.target);
      });

      this.sync(routine);
    });
  },

  async getCart() {
    const response = await fetch(`${this.root}cart.js`, {
      headers: { Accept: "application/json" },
    });

    if (!response.ok) throw new Error("No s'ha pogut consultar la cistella.");
    return response.json();
  },

  async sync(routine) {
    try {
      const cart = await this.getCart();
      const variantIds = new Set(cart.items.map((item) => String(item.variant_id)));

      routine.querySelectorAll(".product-routine__checkbox").forEach((checkbox) => {
        if (!checkbox.closest(".product-routine__item")?.classList.contains("is-loading")) {
          checkbox.checked = variantIds.has(checkbox.value);
        }
      });
    } catch (error) {
      console.error("PRODUCT ROUTINE SYNC ERROR:", error);
    }
  },

  async updateItem(routine, checkbox) {
    const item = checkbox.closest(".product-routine__item");
    const errorMessage = routine.querySelector(".product-routine__error");
    const shouldAdd = checkbox.checked;

    item.classList.add("is-loading");
    checkbox.disabled = true;
    errorMessage.hidden = true;

    try {
      const payload = shouldAdd
        ? { items: [{ id: Number(checkbox.value), quantity: 1 }] }
        : await this.getRemovalPayload(checkbox.value);

      const endpoint = shouldAdd ? "cart/add.js" : "cart/update.js";
      const response = await fetch(`${this.root}${endpoint}`, {
        method: "POST",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          ...payload,
          sections: ["section-cart-notification"],
          sections_url: window.location.pathname,
        }),
      });
      const data = await response.json();

      if (!response.ok) throw new Error(data.description || data.message || "No s'ha pogut actualitzar la cistella.");

      if (window.CartNotification?.updateHTML) {
        window.CartNotification.updateHTML(data);
        window.CartNotification.open();
      }
    } catch (error) {
      checkbox.checked = !shouldAdd;
      errorMessage.textContent = error.message;
      errorMessage.hidden = false;
    } finally {
      item.classList.remove("is-loading");
      checkbox.disabled = false;
      this.sync(routine);
    }
  },

  async getRemovalPayload(variantId) {
    const cart = await this.getCart();
    const updates = {};

    cart.items.forEach((item) => {
      if (String(item.variant_id) === String(variantId)) updates[item.key] = 0;
    });

    return { updates };
  },
};

window.ProductRoutine = ProductRoutine;

document.addEventListener("DOMContentLoaded", () => ProductRoutine.init(document));
document.addEventListener("shopify:section:load", (event) => ProductRoutine.init(event.target));
